import { Tabs } from './Tabs';

// 56px-tall horizontal header bar. Three CSS-grid columns:
//   1. Brand cell (380px)         — wordmark
//   2. Tabs cell  (1fr)           — see Tabs.jsx
//   3. Right cell (auto)          — saved indicator + avatar
//

export function Header({ tab, onTab, user }) {
  return (
    <header className="grid grid-cols-[var(--coach-w)_1fr_auto] h-hdr border-b border-rule bg-paper z-10">
      <div className="flex items-center px-4 border-r border-rule">
        <div className="font-serif text-[17px] leading-none whitespace-nowrap">
          The Portfolio Executive <em className="not-italic text-danger">Companion</em>
        </div>
      </div>

      <Tabs tab={tab} onTab={onTab} />

      <div className="flex items-center">
        <span className="font-mono text-[10px] uppercase tracking-[0.06em] text-ink-3 px-3 border-r border-hairline h-full flex items-center">
          {user ? `saved ${formatTime(user.last_saved_at)}` : 'saved —'}
        </span>
        <div className="flex items-center px-3 h-full">
          <span className="w-[26px] h-[26px] grid place-items-center border border-danger bg-danger-soft font-mono text-[10px] text-danger">
            {user?.initials ?? '··'}
          </span>
        </div>
      </div>
    </header>
  );
}

function formatTime(iso) {
  if (!iso) return '—';
  try {
    const d = new Date(iso);
    return `${String(d.getUTCHours()).padStart(2, '0')}:${String(d.getUTCMinutes()).padStart(2, '0')}`;
  } catch {
    return '—';
  }
}

export default Header;
